import request from '@/utils/request'

/**
 * 根据食品条码编号获取食品基本信息(ndj)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function goodsBasicInfoGet(data) {
  return request({
    type: 'biz',
    url: 'goods/basic/info/get',
    method: 'post',
    data
  })
}
/**
 * 根据食品名称获取食品基本信息(ndj)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function goodsBasicInfoNameGet(data) {
  return request({
    type: 'biz',
    url: 'goods/basic/info/name/get',
    method: 'post',
    data
  })
}
/**
 * 删除食品批次信息(cme)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function goodsBatchDelete(data) {
  return request({
    type: 'biz',
    url: 'goods/batch/delete',
    method: 'post',
    data
  })
}
/**
 * 根据食品批次id获取食品详细信息(cme)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function goodsBatchDetailGet(data) {
  return request({
    type: 'biz',
    url: 'goods/batch/detail/get',
    method: 'post',
    data
  })
}
/**
 * 食品信息录入(ndj)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function goodsBatchInfoAdd(data) {
  return request({
    type: 'biz',
    url: 'goods/batch/info/add',
    method: 'post',
    data
  })
}
/**
 * 获取食品批次列表信息(cme)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function goodsBatchListGet(data) {
  return request({
    type: 'biz',
    url: 'goods/batch/list/get',
    method: 'post',
    data
  })
}
/**
 * 修改食品批次信息(cme)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function goodsBatchUpdate(data) {
  return request({
    type: 'biz',
    url: 'goods/batch/update',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/Goods.js